export const LoginTailor_REQUEST = "LoginTailor_REQUEST";
export const LoginTailor_SUCCESS = "LoginTailor_SUCCESS";
export const LoginTailor_FAIL = "LoginTailor_FAIL";

export const LogoutTailor = "LogoutTailor";

